var exports = {
  "kL": "GuildRosterTab.module__container___RDdxcl",
  "p_": "GuildRosterTab.module__list___RDdxcl",
  "OA": "GuildRosterTab.module__fields___RDdxcl",
  "Nr": "GuildRosterTab.module__card___RDdxcl",
  "UU": "GuildRosterTab.module__name___RDdxcl",
  "SU": "GuildRosterTab.module__muted___RDdxcl",
  "$e": "GuildRosterTab.module__warning___RDdxcl",
  "o1": "GuildRosterTab.module__actions___RDdxcl",
  "LR": "GuildRosterTab.module__sizes___RDdxcl",
  "z3": "GuildRosterTab.module__error___RDdxcl",
};

module.exports = exports;
